<script>
  /* Copyright (c) 2020 Jacques Desodt */
  import { formatTime } from '../scripts/dates'

  export let args = null
  export let hour = true
  export let selected = false
  export let value = 0
  /* Local variables */
  $: style = selected ? 'color:' + args.color + ';' : ''
  $: am = value >= 0 && value < 12
  $: pmHour = args.is24h ? value : value - 12 === 0 ? 12 : value - 12
</script>

<div class="_tp-value" {style} on:click on:keypress role="button" tabindex="0">
  {formatTime(hour ? (am ? value : pmHour) : value)}
</div>

<style>
  ._tp-value {
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    transition-duration: 300ms;
    transition-property: background-color, border-color, color, fill, stroke;
  }
  ._tp-value:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
</style>
